/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Newsletter_Policy_SubjectInputs */

const en_why_listening_newsletter_policy_subject = /** @type {(inputs: Why_Listening_Newsletter_Policy_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New funding rules`)
};

const es_why_listening_newsletter_policy_subject = /** @type {(inputs: Why_Listening_Newsletter_Policy_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevas reglas de financiación`)
};

/**
* | output |
* | --- |
* | "New funding rules" |
*
* @param {Why_Listening_Newsletter_Policy_SubjectInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_newsletter_policy_subject = /** @type {((inputs?: Why_Listening_Newsletter_Policy_SubjectInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Newsletter_Policy_SubjectInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_newsletter_policy_subject(inputs)
	return en_why_listening_newsletter_policy_subject(inputs)
});